import { Box, Typography } from "@mui/material";
import { UserProfileDto, UserStatus } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import LibUtils from "lib/LibUtils";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    user: UserProfileDto | null;
}

/**
 * Painel lateral de outras informações de usuário.
 * @param props
 */
export const PanelUserOtherInfo: React.FC<IProps> = (props) => {
    const user = props.user!;

    const { t } = useTranslation("knowledge");

    const customFields = user?.customFields?.filter(x => x.fieldValue != null && (x.fieldValue.length > 0 || LibUtils.isValidDate(x.fieldValue)));

    ////////////////////////////////////////////////////////////////////////////
    /// Render
    ////////////////////////////////////////////////////////////////////////////

    const RenderData = (label: string, value: string, key: string = label) => {
        return (
            <Box marginY={1}>
                <Typography variant="subtitle1" component="div">
                    <b>{label}</b>
                </Typography>
                <Typography variant="caption" component="div">
                    {value}
                </Typography>
            </Box>
        );
    };

    return user?.birthDate != null || user?.admissionDate != null || user?.dismissedDate != null || (customFields && customFields.length > 0)
        ? (
            <>
                <Typography variant="h3">{t("Feed.Panels.UserOtherInfo.Title")}</Typography>

                {
                    user?.birthDate && user?.status != UserStatus.Deleted &&
                    RenderData(t("Feed.Panels.UserOtherInfo.BirthdayLabel"), moment(user.birthDate).format("DD/MMM"))
                }

                {user?.status == UserStatus.Deleted
                    ? RenderData(
                        t("Feed.Panels.UserOtherInfo.AdmissionPeriodLabel"),
                        Formaters.dateRange(
                            user.admissionDate == null ? user.createdOn : new Date(user.admissionDate),
                            user.dismissedDate == null ? user.deletedOn : new Date(user.dismissedDate)
                        ) ?? "-"
                    )
                    : <>
                        {user?.admissionDate &&
                            RenderData(t("Feed.Panels.UserOtherInfo.AdmissionDateLabel"), moment(user.admissionDate).format("L"))
                        }

                        {user?.dismissedDate &&
                            RenderData(t("Feed.Panels.UserOtherInfo.DismissedDateLabel"), moment(user.dismissedDate).format("L"))
                        }
                    </>
                }

                {
                    user?.status != UserStatus.Deleted && customFields?.map((item, index) => {
                        return (
                            <div key={index}>
                                {RenderData(item.label, (item.fieldValue ?? ""))}
                            </div>
                        );
                    })
                }
            </>
        )
        : null;
};
